var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22.313H7.499A7.51 7.51 0 0 1 0 14.814V7.5A7.51 7.51 0 0 1 7.5 0h17A7.51 7.51 0 0 1 32 7.5v7.313a7.51 7.51 0 0 1-7.5 7.5zM7.5 2.5c-2.757 0-5 2.243-5 5v7.314c0 2.756 2.242 4.999 4.999 4.999H24.5c2.757 0 5-2.243 5-5V7.5c0-2.757-2.243-5-5-5h-17zm6.817 14.128c-.491 0-.981-.128-1.431-.383a2.83 2.83 0 0 1-1.449-2.485V8.866a2.83 2.83 0 0 1 1.449-2.486 2.86 2.86 0 0 1 2.907.027l4.117 2.446c.878.522 1.402 1.441 1.402 2.458s-.524 1.936-1.402 2.458l-4.117 2.446c-.46.274-.968.411-1.476.411zm.199-2.56l4.117-2.446c.148-.088.18-.217.18-.309s-.031-.221-.18-.309l-4.117-2.446c-.17-.101-.319-.046-.393-.004-.085.048-.186.141-.186.313v4.893c0 .171.101.264.186.313.074.042.393-.003.393-.003zM13.438 30.75v-5a1.25 1.25 0 1 0-2.5 0v5a1.25 1.25 0 1 0 2.5 0zM32 28.25A1.25 1.25 0 0 0 30.75 27H17.188a1.25 1.25 0 1 0 0 2.5H30.75A1.25 1.25 0 0 0 32 28.25zm-23.562 0A1.25 1.25 0 0 0 7.188 27H1.25A1.25 1.25 0 0 0 0 28.25a1.25 1.25 0 0 0 1.25 1.25h5.938a1.25 1.25 0 0 0 1.25-1.25z",
    fill: "url(#A)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0,
    y1: 16.077,
    x2: 32,
    y2: 16.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d946ef"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.a5667c7c8d76761d9ab7dd62813a21b4.svg";
export { ForwardRef as ReactComponent };